import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import IconText from './iconText.vue';

@Component({ components: { IconText } })
export default class Pager extends Vue {
  @Prop() private pageInfo!: any;

  @Emit('handle-previous-click')
  public handlePreviousClick(startCursor: string) {}

  @Emit('handle-next-click')
  public handleNextClick(endCursor: string) {}
}
